module.exports = __webpack_public_path__ + "img/15-sjtuiuc-logo.31bf8ce3.png";